import React from 'react';
import { Button } from 'antd';
import { CheckCircleFilled, WarningFilled } from '@ant-design/icons';
import styles from './index.module.css';
import BugHerdCircleLogo from '../../../assets/images/bugherd-logo-circle.svg';
import WhiteLogo from '../../../../../assets/images/icons/bugherd-white-logo.svg';

type Props = {
  helpGuideUrl: string;
  shop?: string | null;
  themeEditorUrl?: string | null;
};

export default function ShopifyInstalled({
  helpGuideUrl,
  shop,
  themeEditorUrl,
}: Props) {
  return (
    <div className={styles.page}>
      <WhiteLogo className={styles.wordmark} />

      <div className={styles.centered}>
        <div className={styles.card}>
          <div className={styles.intro}>
            <BugHerdCircleLogo className={styles.icon} />
            <h1 className={styles.title}>Shopify plugin installed</h1>
            {shop && (
              <p className={styles.storeName}>
                Store: <strong>{shop}</strong>
              </p>
            )}
          </div>

          <div className={styles.stepsPanel}>
            <p className={styles.stepsIntro}>Next, follow the steps below to enable BugHerd in your Shopify theme:</p>

            <div className={styles.stepsList}>
              <div className={styles.step}>
                <CheckCircleFilled className={styles.stepIcon} />
                <p className={styles.stepText}>
                  Click <strong>"Open theme editor"</strong> to open Shopify.
                </p>
              </div>
              <div className={styles.step}>
                <CheckCircleFilled className={styles.stepIcon} />
                <p className={styles.stepText}>
                  Follow the instructions in{' '}
                  <a href={helpGuideUrl} target="_blank" rel="noopener noreferrer">
                    our installation guide
                  </a>{' '}
                  to enable the plugin.
                </p>
              </div>
            </div>
          </div>

          {!themeEditorUrl && (
            <div className={styles.warningPanel}>
              <WarningFilled className={styles.warningIcon} />
              <p className={styles.warningText}>
                We could not determine your Shopify store from the install callback.
                Use the help guide below to finish setup manually.
              </p>
            </div>
          )}

          <Button
            className={styles.primaryButton}
            type="primary"
            size="large"
            block
            href={themeEditorUrl}
            target="_blank"
            rel="noopener noreferrer"
            disabled={!themeEditorUrl}
          >
            Open theme editor
          </Button>
        </div>
      </div>
    </div>
  );
}
